import Vue from 'vue';

Vue.filter('moneyDBtoDisplay', (
  value = 0,
  showSignal = false
) => {
  let signal = '+';

  if (value < 0) {
    signal = '-';
  }

  if (showSignal == false) {
    signal = '';
  }

  if (!value || value == 0) {
    return '0,00';
  }

  let objTextBox = {
    value: parseFloat(value).toFixed(2).replace(".", "")
  };
  let SeparadorMilesimo = '.';
  let SeparadorDecimal = ',';
  // let e = event;
  let j = 0;
  let i = 0;
  // let sep = 0
  let key = '';
  let len = 0;
  let len2 = 0;
  let strCheck = '0123456789';
  let aux = '';
  let aux2 = '';
  // let whichCode = (window.Event) ? e.which : e.keyCode;
  //if (whichCode == 13) return true;
  // key = String.fromCharCode(whichCode); // Valor para o código da Chave
  // if (strCheck.indexOf(key) == -1) return false; // Chave inválida
  //return objTextBox.value.length;
  len = objTextBox.value.length;
  for (i = 0; i < len; i++)
    if ((objTextBox.value.charAt(i) != '0') && (objTextBox.value.charAt(i) != SeparadorDecimal)) break;
  aux = '';
  for (; i < len; i++)
    if (strCheck.indexOf(objTextBox.value.charAt(i)) != -1) aux += objTextBox.value.charAt(i);
  aux += key;
  len = aux.length;
  if (len == 0) objTextBox.value = '';
  if (len == 1) objTextBox.value = '0' + SeparadorDecimal + '0' + aux;
  if (len == 2) objTextBox.value = '0' + SeparadorDecimal + aux;
  if (len > 2) {
    aux2 = '';
    for (j = 0, i = len - 3; i >= 0; i--) {
      if (j == 3) {
        aux2 += SeparadorMilesimo;
        j = 0;
      }
      aux2 += aux.charAt(i);
      j++;
    }
    objTextBox.value = '';
    len2 = aux2.length;
    for (i = len2 - 1; i >= 0; i--)
      objTextBox.value += aux2.charAt(i);
    objTextBox.value += SeparadorDecimal + aux.substr(len - 2, len);
  }

  return signal + objTextBox.value;

})

Vue.filter('toInteger', ( value = 0) => {
  return parseFloat(value).toFixed(0);
})